import React, { useEffect, useState } from "react";
import { StyleSheet, View } from "react-native";
import _ from 'lodash'
import ThemedBlock from 'components/atoms/ThemedBlock'
import Timeslot from 'components/molecules/Timeslot'
import Form from 'components/molecules/Form'
import HelperManagementRights from 'utils/helper-management-rights'
import { managementRightsConstants } from 'utils/constants/management-right-constants'
import FetchTimeslotKinds from 'utils/fetch/FetchTimeslotKinds'
import LoadingComponent from 'components/atoms/Loading'
import { FormFieldsConstants } from 'utils/constants/form-constants';
import HelperDate, { dateFormat } from 'utils/helper-date'

const ManagementTimeslotGroupTimeslotKindsTab = ( { saveForm, updateTimeslotGroup, timeslotGroup, isSaving }) => {
	
	const [ timeslotKinds, setTimeslotKinds ] = useState( null );
	
	const [ isLoading, setIsLoading ] = useState( true );
	const loading = () => {
		setIsLoading(true);
	}
	const loaded = () => {
		setIsLoading(false);
	}
	
	const fetchedTimeslotKinds = ( timeslotKinds ) => {
		setTimeslotKinds( timeslotKinds );
		loaded();
	}
	
	const fetchTimeslotKinds = () => {
		FetchTimeslotKinds.fetchAll( {
			callbackStart: loading,
			callbackError: loaded,
			callbackSuccess: fetchedTimeslotKinds
		});
	}
	
	useEffect( () => {
		fetchTimeslotKinds();
	}, [])
	
	const formFields = [];
	
	_.forEach( timeslotKinds, ( timeslotKind ) => {
		const fakeBooking = {
			timeslot: {
				booking_date: HelperDate.date().format( dateFormat.DATE ),
				timeslot_start: '09:00',
				timeslot_end: '18:00',
				capacity: 20,
				...timeslotKind
			}
		};
		
		formFields.push({
			name: `[timeslotKind|${timeslotKind.guid}]`,
			label: (
				<View style={ staticStyles.viewAlignItemsCenterFlex1 }>
					<View style={  staticStyles.viewWidth400 }>
						<ThemedBlock shadow>
							<Timeslot
								item={ fakeBooking }
								itemProps={ { showCapacity: true } }
								timeslotKind={ timeslotKind }
								timeslotIconOverWriteProperties={ timeslotKind }
							/>
						</ThemedBlock>
					</View>
				</View>
			),
			type: FormFieldsConstants.SELECT_ACTIVE,
		});
		
		formFields.push({type: FormFieldsConstants.DIVIDER });
	});
	
	return (
		<ThemedBlock
			shadow
			mediumPadding>
			
			{ isLoading && (
				<LoadingComponent />
			)}
			
			<Form
				values={ timeslotGroup }
				fields={ formFields }
				onChange={ updateTimeslotGroup }
				onSubmit={ saveForm }
				disabled={ !HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) || isSaving }
				forceSaveButton={ true }
			/>
		</ThemedBlock>
	);
}


const staticStyles = StyleSheet.create({
	viewAlignItemsCenterFlex1: {
		alignItems: 'center',
		flex: 1,
		marginBottom: 4,
	},
	viewWidth400: {
		width: 400,
	},
});

export default ManagementTimeslotGroupTimeslotKindsTab
